import { Button, Modal, ModalBody } from 'reactstrap';

export type ConfirmModalProps = {
    isOpen: boolean;
    toggle: () => void;
    title: string;
    message?: string;
    handleConfirm: () => void;
    saving: boolean;
    isDeleting?: boolean;
};

export const ConfirmModal = (props: ConfirmModalProps) => {
    const {
        isOpen,
        toggle,
        handleConfirm,
        title,
        message,
        saving,
        isDeleting,
    } = props;

    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <h3 className='text-modal modal__title'>{title}</h3>
                {message && message.length > 0 && (
                    <p style={{ marginBottom: '40px' }}>{message}</p>
                )}
                <Button color='outline-dark' onClick={toggle} disabled={saving}>
                    Cancel
                </Button>
                <Button
                    color={isDeleting ? 'danger' : 'primary'}
                    onClick={handleConfirm}
                    disabled={saving}
                >
                    {saving ? `Saving` : isDeleting ? `Delete` : `Ok`}
                </Button>
            </ModalBody>
        </Modal>
    );
};
